import { ValidationResult } from '@classifieds-sell/datalayer';
import {
    StepDisabledStates,
    StepTouchedStates,
    StepValidityStates,
    StepModel
} from '@classifieds-sell/shared';

export const updateSteps = (
    currentPropertySteps: StepModel[],
    validationResults: ValidationResult[]
): StepModel[] => {
    if (validationResults === null) {
        return currentPropertySteps;
    }
    const updatedSteps = currentPropertySteps.map((propertyStep) => {
        const index = validationResults.findIndex(
            (v) => v.stepId === propertyStep.stepId
        );
        if (index !== -1 && validationResults[index].isValid !== null) {
            return {
                ...propertyStep,
                disabledState: StepDisabledStates.enabled,
                validity:
                    validationResults[index].isValid === true
                        ? StepValidityStates.valid
                        : StepValidityStates.invalid,
                touchedState: StepTouchedStates.touched
            } as StepModel;
        }

        return propertyStep;
    });

    return updatedSteps;
};

export const isStepEnabled = (
    currentPropertySteps: StepModel[],
    currentStepId: string
): boolean => {
    return currentPropertySteps.some(
        (s) =>
            s.stepId === currentStepId &&
            s.disabledState === StepDisabledStates.enabled
    );
};

export const getAdjacentSteps = (
    currentPropertySteps: StepModel[],
    currentStepId: string
): string[] => {
    const currentStepIndex = currentPropertySteps.findIndex(
        (s) => s.stepId === currentStepId
    );

    let prevStepId: string = null;
    let nextStepId: string = null;

    if (currentStepIndex > 0) {
        prevStepId = currentPropertySteps[currentStepIndex - 1].stepId;
    }

    if (currentStepIndex < currentPropertySteps.length - 1) {
        nextStepId = currentPropertySteps[currentStepIndex + 1].stepId;
    }

    return [prevStepId, nextStepId];
};
